import { all, call, put, takeLatest } from 'redux-saga/effects';
import { STORY } from 'src/store/ActionTypes';

import * as api from 'src/store/api';

function* fetchSegments(action) {
  try {
    const { payload: query } = action;
    const segments = yield call(api.fetchSegments, query);
    yield put({
      type: STORY.FETCH_SEGMENTS_SUCCEEDED,
      payload: segments,
    });
  } catch (e) {
    yield put({
      type: STORY.FETCH_SEGMENTS_FAILED,
    });
  }
}

function* fetchStories(action) {
  try {
    const { payload: query } = action;
    const stories = yield call(api.fetchStories, query);
    const storyPromises = stories.map(async (story) => {
      const { slides } = story;
      const slidesPromises = slides.map(async (slide) => {
        if (slide.imageUrl) {
          const presignedUrl = await api.getS3DownloadUrl(slide.imageUrl);
          return {
            ...slide,
            presignedUrl,
          };
        }
        return slide;
      });
      const newSlides = await Promise.all(slidesPromises);
      return {
        ...story,
        slides: newSlides,
      };
    });
    const newStories = yield all(storyPromises);
    yield put({
      type: STORY.FETCH_STORIES_SUCCEEDED,
      payload: newStories,
    });
  } catch (e) {
    yield put({
      type: STORY.FETCH_STORIES_FAILED,
    });
  }
}

function* fetchSegmentsSaga() {
  yield takeLatest(STORY.FETCH_SEGMENTS, fetchSegments);
}

function* fetchStoriesSaga() {
  yield takeLatest(STORY.FETCH_STORIES, fetchStories);
}

export default [fetchSegmentsSaga(), fetchStoriesSaga()];
